import { desktopFirstMediaQuery } from '@inflearn/ds-react';

export const MobileOnlyBreak = () => {
  return (
    <br
      css={{
        display: 'none',

        [desktopFirstMediaQuery.mobile]: {
          display: 'block',
        },
      }}
    />
  );
};
